export const selectCartDetails = state => state.cartReducer || {};